import { setupWorker } from 'msw/browser';
import { demoHandlers } from './handlers';

/** Singleton MSW service worker instance */
let worker: ReturnType<typeof setupWorker> | null = null;

/**
 * Start the MSW service worker for demo mode.
 * Intercepts all fetch/XHR requests matching demo API handlers.
 * Safe to call multiple times — no-op if already running.
 */
export async function startDemoWorker(): Promise<void> {
  if (worker) return; // Already running

  worker = setupWorker(...demoHandlers);

  await worker.start({
    serviceWorker: {
      url: '/mockServiceWorker.js',
      // Disable cache to avoid stale worker version during development
      options: { updateViaCache: 'none' as ServiceWorkerUpdateViaCache },
    },
    // Critical: let fonts, Sentry, Vite HMR, and asset requests pass through
    onUnhandledRequest: 'bypass',
    quiet: true, // Suppress noisy MSW console output in demo
  });
}

/**
 * Stop the MSW service worker and clean up.
 * Called on demo exit to restore normal API behavior.
 */
export async function stopDemoWorker(): Promise<void> {
  if (!worker) return;
  worker.stop();
  worker = null;
}
